import { CountryCode } from "libphonenumber-js";

export interface IOrganisationInfo {
    name: string;
    logoUrl: string;
    backgroundColor: string;
    bookingInstructions: string;
    termsAndConditions: string;
    newUsersCanRegister: boolean;
    classesAreEnabled: boolean;
    groupBookingLabel: string;
    stripePublishableKey: string;
    stripeAccount: string;
    portalPayments: ClientPortalPaymentModes;
    groupPortalPayments: ClientPortalPaymentModes;
    locale: string;
    currency: string;
    currencySymbol: string;
    tokenVia: string;
    taxUsage: TaxUsageType;
    countryCode: CountryCode;
    clientPortalEnabled: boolean;
    shouldShowClientPortalLogin: boolean;
    sgId: string;
}

export enum ClientPortalPaymentModes {
    Disabled,
    Optional,
    Required,
}

export enum TaxUsageType {
    Including,
    Excluding,
    NoTax,
}
